export const OGDB_CACHE_TAG = 'ogdb';
